import { logger as E } from "../../shared-lib/index.js";
import { getErrorMessage as si } from "./error-utils.js";
export function _isInView(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  if (null == t) return !1;
  n = n || !1, e = e || !1;
  var i = t.getBoundingClientRect();
  return null != i && (i.top >= 0 && i.top <= (window.innerHeight || document.documentElement.clientHeight) || !n) && (i.left >= 0 || !s) && (i.bottom >= 0 && i.bottom <= (window.innerHeight || document.documentElement.clientHeight) || !e) && (i.right <= (window.innerWidth || document.documentElement.clientWidth) || !s);
}
export var DOMUtils = {
  Ic: null,
  Mo: _isInView
};
export var DIRECTIONS = {
  ko: "up",
  xo: "down",
  Zt: "left",
  ae: "right"
};
export function supportsPassive() {
  if (null == DOMUtils.Ic) {
    DOMUtils.Ic = !1;
    try {
      var t = Object.defineProperty({}, "passive", {
        get: function get() {
          DOMUtils.Ic = !0;
        }
      });
      window.addEventListener("testPassive", function () {}, t), window.removeEventListener("testPassive", function () {}, t);
    } catch (t) {
      E.error(si(t));
    }
  }
  return DOMUtils.Ic;
}
export function addPassiveEventListener(t, n) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  t.addEventListener(n, e, !!supportsPassive() && {
    passive: !0
  });
}
export function topIsInView(t) {
  return DOMUtils.Mo(t, !0, !1, !1);
}
export function bottomIsInView(t) {
  return DOMUtils.Mo(t, !1, !0, !1);
}
export function clickElement(t) {
  if (t.onclick) {
    var n = document.createEvent("MouseEvents");
    n.initEvent("click", !0, !0), t.onclick.apply(t, [n]);
  }
}
export function detectSwipe(t, n, e) {
  var s = null,
    i = null;
  addPassiveEventListener(t, "touchstart", function (t) {
    s = t.touches[0].clientX, i = t.touches[0].clientY;
  }), addPassiveEventListener(t, "touchmove", function (o) {
    if (null == s || null == i) return;
    var l = s - o.touches[0].clientX,
      u = i - o.touches[0].clientY;
    Math.abs(l) > Math.abs(u) && Math.abs(l) >= 25 ? ((l > 0 && n === DIRECTIONS.Zt || l < 0 && n === DIRECTIONS.ae) && e(o), s = null, i = null) : Math.abs(u) >= 25 && ((u > 0 && n === DIRECTIONS.ko && t.scrollTop === t.scrollHeight - t.offsetHeight || u < 0 && n === DIRECTIONS.xo && 0 === t.scrollTop) && e(o), s = null, i = null);
  });
}
export function buildSvg(t, n, e) {
  var s = "http://www.w3.org/2000/svg",
    i = document.createElementNS(s, "svg");
  i.setAttribute("viewBox", t), i.setAttribute("xmlns", s);
  var o = document.createElementNS(s, "path");
  return o.setAttribute("d", n), null != e && o.setAttribute("fill", e), i.appendChild(o), i;
}